import {all, fork} from "redux-saga/effects"
import {put, takeEvery} from "@redux-saga/core/effects"
import {
    deleteElement,
    deleteElementError,
    deleteElementSuccess,
    getAllElement,
    getAllElementError,
    getAllElementErrorShedNotPageable,
    GetAllElementPayloadShed,
    getAllElementShedNotPageable,
    getAllElementSuccess,
    getAllElementSuccessShedNotPageable,
    saveElement,
    saveElementError,
    saveElementSuccess,
    shedAction,
    shedActionError,
    shedActionSuccess,
    ShedElement,
    updateElement,
    updateElementError,
    updateElementSuccess,
} from "../reducers/Shed/ShedReducer"
import {CustomFetch, CustomFetchResponse} from "../utils/CustomFetch"
import apiPaths from "../config/apiPaths"
import {PayloadAction} from "@reduxjs/toolkit"
import {openSnackbar} from "../reducers/snackbar/snackbarReducer"


interface ShedFilter {
    name: string | null
}

function* getAllElementSaga() {
    yield takeEvery(getAllElement.type, function* (action: PayloadAction<GetAllElementPayloadShed>) {

        if (!action.payload || !action.payload.pageableDto) {
            console.error("Invalid payload or pageableDto is undefined!")
            yield put({type: getAllElementError.type})
            return
        }
        try {
            let response: CustomFetchResponse


            let filters: ShedFilter = {
                name: action.payload.filters?.find(filter => filter.id === "name")?.value as string ?? ""
            }

            let requestPayload = {
                ...action.payload.pageableDto,
                filters: filters
            }

            response = yield CustomFetch({
                method: "POST",
                url: apiPaths.filterShed, // Percorso API specifico per il filtro
                authenticated: true,
                data: requestPayload,
            })
            if (response.status === 200) {
                yield put({type: getAllElementSuccess.type, payload: response.data})
            } else {
                yield put({type: getAllElementError.type})
            }
        } catch (error) {
            console.error("Error in getAllElementSaga:", error)
            yield put({type: getAllElementError.type})
        }
    })
}

function* shedAudit() {
    yield takeEvery(shedAction.type, function* (action: PayloadAction<string>) {
        const url = `${apiPaths.actionShed}/${action.payload}`

        let response: CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: url,
            authenticated: true,
        })

        if (response.status === 200) {
            yield put({type: shedActionSuccess.type, payload: response.data})

        } else {
            yield put({type: shedActionError.type})

        }
    })
}

// function* saveNormalShed(){
//     yield takeEvery(saveElementShed.type, function* (action: PayloadAction<ShedElement>){
//         let response : CustomFetchResponse = yield CustomFetch({
//             method: "POST",
//             url: apiPaths.saveUserNormal,
//             authenticated: true,
//             data: action.payload
//         })

//         if(response.status === 200){
//             console.log(response.data)
//             yield put({type: saveElementShedSuccess.type, payload: response.data})
//             yield put({
//                 type: openSnackbar.type, payload: {
//                     open: true,
//                     message: 'Element User added successfully',
//                     variant: 'alert',
//                     alert: {
//                         color: 'success'
//                     }
//                 }
//             })
//             yield put({
//                 type: getAllElement.type,
//                 payload: {
//                     pageableDto: {
//                         page: select(state => state.user.currentPage),
//                         size: select(state => state.user.rowsPerPage)
//                     }

//                 }
//             } ,)

//         } else {
//             console.log(response.data)
//             yield put({type: saveElementShedError.type})
//             yield put({
//                 type: openSnackbar.type, payload: {
//                     open: true,
//                     message: 'Error insert User',
//                     variant: 'alert',
//                     alert: {
//                         color: 'error'
//                     }
//                 }
//             })
//         }
//     })
// }


function* getAllElementNotPageableSaga() {
    yield takeEvery(getAllElementShedNotPageable.type, function* (action: PayloadAction<ShedElement>) {
        let response: CustomFetchResponse = yield CustomFetch({
            method: "GET",
            url: apiPaths.allShedNotPageable,
            authenticated: true,
        })
        if (response.status === 200) {
            yield put({type: getAllElementSuccessShedNotPageable.type, payload: response.data})
        } else {
            yield put({type: getAllElementErrorShedNotPageable.type})
        }
    })
}

function* saveElementSaga() {
    yield takeEvery(saveElement.type, function* (action: PayloadAction<{ shed: ShedElement, callback: () => void }>) {
        const savePayload = {
            name: action.payload.shed.name,
            boxes: action.payload.shed.boxes
        }

        let response: CustomFetchResponse = yield CustomFetch({
            method: "POST",
            url: apiPaths.saveShed,
            authenticated: true,
            data: savePayload
        })

        if (response.status === 200) {

            yield put({type: saveElementSuccess.type, payload: response.data})
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element added successfully',
                    variant: 'alert',
                    alert: {color: 'success'}
                }
            })

            action.payload.callback();


        } else {
            yield put({type: saveElementError.type})
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Element not saved',
                    variant: 'alert',
                    alert: {color: 'error'}
                }
            })
        }
    })
}

const updateElementSaga = function* () {
    yield takeEvery(updateElement.type, function* (action: PayloadAction<{ shed: ShedElement, callback: () => void }>) {
        const url = `${apiPaths.updateShed}/${action.payload.shed._id}`

        const updatePayload = {
            name: action.payload.shed.name,
            boxes: action.payload.shed.boxes
        }
        // Logs di debug
        //console.log("Incoming boxes (frontend):", boxes)

        // Prepara il payload


        // Chiamata PUT al backend
        let response: CustomFetchResponse = yield CustomFetch(
            {
                method: "PUT",
                url: url,
                authenticated: true,
                //  data: action.payload
                data: updatePayload
            }
        )
        // Gestione della risposta
        if (response.status === 200) {
            yield put({type: updateElementSuccess.type, payload: response.data})

            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Shed updated successfully',
                    variant: 'alert',
                    alert: {color: 'success'}
                }
            })
            action.payload.callback();

        } else {
            console.error("Error updating shed:", response)
            yield put({type: updateElementError.type})
            yield put({
                type: openSnackbar.type,
                payload: {
                    open: true,
                    message: 'Shed not updated',
                    variant: 'alert',
                    alert: {color: 'warning'}
                }
            })
        }
    })
}


function* deleteElementSaga() {
    yield takeEvery(deleteElement.type, function* (action: PayloadAction<{ id: string, callback: () => void }>) {

        const url = `${apiPaths.deleteShed}/${action.payload.id}`
        let response: CustomFetchResponse = yield CustomFetch({
            method: "DELETE",
            url: url,
            authenticated: true
        })

        if (response.status === 200) {

            action.payload.callback()
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element  deleted ',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
            yield put({type: deleteElementSuccess.type, payload: response.data.content})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element  deleted ',
                    variant: 'alert',
                    alert: {
                        color: 'success'
                    }
                }
            })
        } else {
            yield put({type: deleteElementError.type})
            yield put({
                type: openSnackbar.type, payload: {
                    open: true,
                    message: 'Element not deleted ',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    }
                }
            })
        }

    })
}

// function* filterElementSaga() {
//     yield takeEvery(filterElement.type, function* (action: PayloadAction<ColumnFiltersState>) {
//         console.log("Action payload:", action.payload)

//         const payload = action.payload
//         const baseUrl = `${apiPaths.filterShed}` // Base URL dell'API

//         try {
//             // Estrai il filtro "name" dal payload
//             const nameFilter = payload.find(filter => filter.id === "name")?.value as string

//             // Validazione dei parametri
//             if (!nameFilter) {
//                 console.error("Missing 'name' filter. Request will not proceed.")
//                 yield put({
//                     type: openSnackbar.type,
//                     payload: {
//                         open: true,
//                         message: "Name filter is required.",
//                         variant: "alert",
//                         alert: { color: "error" },
//                     },
//                 })
//                 return // Blocca la saga se il filtro non è presente
//             }

//             // Costruzione della query string
//             const queryParams = new URLSearchParams({ name: nameFilter })
//             console.log("Query params:", queryParams.toString())

//             // Effettua la richiesta GET con i parametri
//             const response: CustomFetchResponse = yield CustomFetch({
//                 method: "GET",
//                 url: `${baseUrl}?${queryParams.toString()}`, // URL con parametri query
//                 authenticated: true, // La richiesta è autenticata
//             })

//             // Verifica se la risposta è OK
//             if (response.status === 200) {
//                 // Estrarre i dati dalla risposta
//                 const filterData = response.data.content || [] // Dati filtrati
//                 const totalElements = response.data.totalElements || 0 // Numero totale di elementi
//                 const currentPage = response.data.currentPage ?? 1 // Pagina corrente

//                 console.log("Filtered data:", filterData)

//                 // Aggiornare lo stato con i dati ricevuti
//                 yield put({
//                     type: filterElementSuccess.type,
//                     payload: {
//                         data: filterData,
//                         currentPage,
//                         totalRows: totalElements,
//                     },
//                 })

//                 // Mostrare un messaggio di successo
//                 yield put({
//                     type: openSnackbar.type,
//                     payload: {
//                         open: true,
//                         message: "Filter applied successfully",
//                         variant: "alert",
//                         alert: { color: "success" },
//                     },
//                 })
//             } else {
//                 console.error("Server returned an error:", response.data)

//                 // Dispatch errore al reducer
//                 yield put({ type: filterElementError.type })

//                 // Mostrare un messaggio di errore
//                 yield put({
//                     type: openSnackbar.type,
//                     payload: {
//                         open: true,
//                         message: "Failed to apply filter",
//                         variant: "alert",
//                         alert: { color: "error" },
//                     },
//                 })
//             }
//         } catch (error) {
//             console.error("Network error:", error)

//             // Dispatch errore al reducer
//             yield put({ type: filterElementError.type })

//             // Mostrare un messaggio di errore
//             yield put({
//                 type: openSnackbar.type,
//                 payload: {
//                     open: true,
//                     message: "An error occurred while applying filter",
//                     variant: "alert",
//                     alert: { color: "error" },
//                 },
//             })
//         }
//     })
// }


export default function* ShedSaga() {
    yield all(
        [
            fork(getAllElementSaga),
            fork(saveElementSaga),
            fork(updateElementSaga),
            fork(deleteElementSaga),
            fork(getAllElementNotPageableSaga),
            fork(shedAudit)
        ],
    )
}